import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';
import { SamplesModule } from "@app/samples/samples.module";
import { SamplesComponent } from '@app/samples/samples.component';

const apiUrl = 'https://mnc-dev-api-wcc.azurewebsites.net';

export const environment: IEnvironment = {
  apiUrl,
  modules: [
    SamplesModule
  ],
  production: false,
  routes: [
    {
      path: ':tenantId/wcc',
      component: SamplesComponent,
      children: [
        // Add Sample pages here. Use the code below as a guide.
        // { path: 'wcc-component', component: SamplePageComponent, data: { title: 'WCC Component' } },
      ]
    },
  ],
  version: buildVersion as BuildVersion,
  wccLibraryUrl: 'https://mncregstage.blob.core.windows.net/documentlibrary/hh/wcc/library',
};
